/**
 * Web clipper inbox (ADR 0022): the browser extension inserts rows in `clips`;
 * an open app takes each one with delete … returning, so when two devices are
 * open only one of them gets it, and hands it over (it becomes a page).
 */
import type { SupabaseClientAnySchema } from './remote';

export interface ClipRow {
  id: string;
  created_at: string;
  title: string;
  url: string | null;
  markdown: string;
  note: string | null;
}

/** Take the waiting clips (oldest first); returns how many this device got. */
export async function takeClips(
  sb: SupabaseClientAnySchema,
  onClip: (clip: ClipRow) => Promise<unknown>,
  limit = 20,
): Promise<number> {
  const { data, error } = await sb.from('clips').select('id').order('created_at').limit(limit);
  if (error) throw error;
  let taken = 0;
  for (const { id } of data as { id: string }[]) {
    const { data: rows, error: claimError } = await sb.from('clips').delete().eq('id', id).select();
    if (claimError) throw claimError;
    const clip = (rows as ClipRow[])[0];
    if (!clip) continue; // another device took it
    await onClip(clip);
    taken++;
  }
  return taken;
}
